var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    (!_vm.$store.getters['auth/logged_in'] && _vm.$route.name !== 'residences' && _vm.$route.name !== 'residences-list') ||
      _vm.$route.name === 'null'
  )?_c('div',[_c('app-content-empty')],1):(_vm.$route.name !== 'iframe' && _vm.$route.name !== 'login')?_c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('app-content'),_c('app-footer')],1):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }